import { useNavigate } from "react-router-dom"
import { useAuth } from "@/hooks/use-auth"

interface LoginDialogProps {
  children: React.ReactNode
  /** When true, children are already focusable (e.g. SidebarMenuButton); wrapper stays a plain div. */
  interactiveChild?: boolean
}

export function LoginDialog({ children, interactiveChild = true }: LoginDialogProps) {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()

  // If user is already authenticated, just return the children
  if (isAuthenticated) {
    return <>{children}</>
  }

  const navigateToLogin = () => navigate('/login')

  // Interactive children receive focus; their click bubbles to the wrapper onClick.
  if (interactiveChild) {
    return (
      <div onClick={navigateToLogin} className="cursor-pointer">
        {children}
      </div>
    )
  }

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Sign in to continue"
      className="cursor-pointer"
      onClick={navigateToLogin}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          navigateToLogin()
        }
      }}
    >
      {children}
    </div>
  )
}
